// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"195":"af40ec8f","284":"bd141983","309":"55d4125d","385":"cfa5fe4b","454":"66fd48a5","651":"e9e76d84","705":"7e401e3e","839":"64d06401","964":"bf352a45"}[chunkId] + ".chunk.js";
};